angular
    .module('backOffice')
    .controller('ConfigureStopPaymentController', configureStopPaymentController);

configureStopPaymentController.$inject = [
    '$scope',
    '$modalInstance',
    'modalService',
    'configurationService',
    'productFeatureId',
    'canEdit',
    'toaster',
];

function configureStopPaymentController(
    $scope,
    $modalInstance,
    modalService,
    configurationService,
    productFeatureId,
    canEdit,
    toaster
) {
    $scope.productFeatureId = productFeatureId;
    $scope.canEdit = canEdit;

    $scope.approvalOptions = ['None', 1, 2, 3];
    $scope.productFeature = {};

    $scope.save = save;
    $scope.cancel = cancel;

    function save() {
        if ($scope.productFeature.approvalCount === 'None') {
            $scope.productFeature.approvalCount = 0;
        }
        configurationService
            .saveProductFeature($scope.productFeatureId, $scope.productFeature)
            .then(response => {
                toaster.save('Stop Payment Configuration');
                $modalInstance.close();
            });
    }

    function cancel() {
        if ($scope.form.$dirty) {
            const modalOptions = {
                closeButtonText: 'Continue Editing',
                actionButtonText: 'OK',
                headerText: 'Cancel',
                bodyText: 'Are you sure you want to cancel the changes?',
                submit(result) {
                    cancelModalInstance.dismiss();
                    $modalInstance.dismiss();
                },
            };
            var cancelModalInstance = modalService.showModal({}, modalOptions);
        } else {
            $modalInstance.dismiss();
        }
    }

    function init() {
        $scope.productFeature = {
            approvalCount: 'None',
        };

        loadProductFeature();
    }

    function loadProductFeature() {
        configurationService.getProductFeatureDetails($scope.productFeatureId).then(response => {
            $scope.productFeature = response;
            if ($scope.productFeature.approvalCount === 0) {
                $scope.productFeature.approvalCount = 'None';
            }
        });
    }

    init();
}
